var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5166 7.55107C1.63801 5.1014 2.0012 3.57408 3.08768 2.48759C4.17417 1.4011 5.70149 1.03791 8.15117 0.916504M23.6833 7.55107C23.5619 5.1014 23.1987 3.57408 22.1122 2.48759C21.0257 1.4011 19.4984 1.03791 17.0487 0.916504M17.0487 23.0832C19.4984 22.9618 21.0257 22.5986 22.1122 21.5121C23.1987 20.4256 23.5619 18.8983 23.6833 16.4486M8.15116 23.0832C5.70149 22.9618 4.17417 22.5986 3.08768 21.5121C2.0012 20.4256 1.63801 18.8983 1.5166 16.4486",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5166 12H23.6833",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 12C5.6001 8.13401 8.7341 5 12.6001 5C12.6001 6.933 14.1671 8.5 16.1001 8.5C16.8882 8.5 17.6155 8.2395 18.2005 7.79992C19.0793 8.96986 19.6001 10.4241 19.6001 12M18.6636 15.5C17.4533 17.5923 15.1911 19 12.6001 19C10.0091 19 7.74691 17.5923 6.53657 15.5",
    stroke: "#003636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanlight);
export default __webpack_public_path__ + "static/media/scanlight.6ee74c38365d3e53577e2d63bb0c6907.svg";
export { ForwardRef as ReactComponent };